module.exports = __webpack_public_path__ + "static/Colliery_Business_Park-0452af792b70e172f343a58ff16622ab.pdf";